module.exports = __webpack_public_path__ + "img/file.c34a608f.svg";